import React from "react";
import { Link } from "gatsby"
import "../BlogAuthor/BlogAuthor.scss";

const BlogAuthor = (props) =>{
    return(
     <div className="blog-author-section">
      <div className="blog-author-img">
          {props?.data?.Author_Image?.url &&
            <img src={props?.data?.Author_Image?.url} alt={props?.Author_Image?.alternativeText}/>
          } 
      </div>
        <div className="blog-author-content">
          <h2 className="name">{props?.data?.Name}</h2>
          <p className="designation">{props?.data?.Designation}</p>
          <p className="desc">{props?.data?.Description}</p>
          <Link to={props?.data?.Bio_Link} className="btn">Read full bio</Link>
        </div>
     </div>
    );
}
export default BlogAuthor